import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';

interface ILayoutProps {
  height?: number;
}

const SCROLL_PADDING_OFFSET = 22;

const Layout = styled.ul<ILayoutProps>`
  display: flex;
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  padding: ${toRem(22)} 0;
  list-style: none;
  overflow: hidden;
  overflow-y: auto;

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-grow: 0;
    height: ${({ height }) => (height ? toRem(height + SCROLL_PADDING_OFFSET) : 'auto')};
  }
`;

interface IUserListProps {
  itemsVisible?: number;
  children?: React.ReactNode;
  className?: string;
}

const UserList = ({ itemsVisible = 10, children, className }: IUserListProps) => {
  const height = itemsVisible * theme.user.item.height;

  return (
    <Layout className={className} height={height}>
      {children}
    </Layout>
  );
};

export default UserList;
